import { render, staticRenderFns } from "./approvalline.vue?vue&type=template&id=0bf3628c"
import script from "./approvalline.vue?vue&type=script&lang=js"
export * from "./approvalline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports